import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Formik } from "formik";
import { Button, FormGroup, Form, Table } from "reactstrap";
import { ClipLoader } from "react-spinners";

import "./index.css";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import {
  storeMedia,
  getSignedUrlApiAction,
} from "../../../../services/Store/Actions/appActions";
import moment from "moment";

import { saveVehicleProfileData, getVehicleProfileData, getUpdateFleet, editVehicleProfileData, advancedVehicleListAction } from "../../../../services/Store/Actions/fleetActions";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import ImageModal from "../../imageModal";

function ProfileUpdateRender(props) {
    const { type,value ,data,fleetId,create, renderType,serviceHistory,serviceHistoryCount, iter } = props;
    const { advancedVehicleList } = useSelector(
      (state) => state?.fleet
    );
    const vehicle = advancedVehicleList?.filter(
      (element) => element.fleetId == fleetId
    )[0];
    console.log("vehicle", vehicle, fleetId);
    const datepickerRefServiceDate = useRef();
    const handleClickDatepickerIcon = () => {
        const datepickerElement = datepickerRefServiceDate.current;
        datepickerElement.setOpen(!datepickerElement.open);
      };
    const dispatch = useDispatch();
    const [statusImage, setstatusImage] = useState(false);
    const [displayNameImage, setDisplayNameImage] = useState([]);
    const [imageLoader, setImageLoader] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    console.log("ProfileUpdateRender",type,value,data,create, renderType, serviceHistory,serviceHistoryCount, iter );
    const documentId = "profileUpdateRenderPage"
    const notify =  (msg, isError = false) => {
        console.log("ajshgvdkba");
        if(isError){
            toast.error(msg || "failed", {
                toastId: documentId,
            })
        }else{
            toast.success(msg || "success", {
                toastId: documentId,
            })
        }
       
    }
    const [prevData, setPrevData] = useState({})
    const [nextData, setNextData] = useState({})
    useEffect(()=> {
        if(renderType == 'edit' || renderType == 'insert' ){
            if(iter == 0){
                setNextData({})
                setPrevData(serviceHistory[iter+1])
            }else if(iter == serviceHistoryCount-1){
                setPrevData({})
                setNextData(serviceHistory[iter-1])
            }else{
                setPrevData(serviceHistory[iter+1])
                setNextData(serviceHistory[iter-1])
            }
        }
    },[])
    
    let odometerCheck = Yup.number()
    let minDate = new Date()
    let maxDate = new Date()
    if(renderType == 'edit' ){
        if(iter == 0 && serviceHistoryCount == 1){
            minDate = null
        }else{
            if(iter != serviceHistoryCount-1 ){
                odometerCheck = odometerCheck.min(prevData?.odometer+1,`must be greater than previous service ${prevData?.odometer} km!` )
                minDate = new Date(prevData.serviceDate)
            }else{
                minDate = null
            }
            if(iter != 0 ){
                odometerCheck = odometerCheck.max(nextData?.odometer-1,`must be less than next service ${nextData?.odometer} km!` )
                maxDate = new Date(nextData.serviceDate)
            }else{
                minDate = new Date(prevData.serviceDate)
            }
        }
    }
    else if(renderType == 'insert' ){
        odometerCheck = odometerCheck.max(data?.odometer-1,`must be less than selected service ${data?.odometer} km!` )
        maxDate = new Date(data.serviceDate)
        if(iter != serviceHistoryCount-1 ){
            odometerCheck = odometerCheck.min(prevData?.odometer+1,`must be greater than previous service ${prevData?.odometer} km!` )
            minDate = new Date(prevData.serviceDate)
        }else{
            minDate=null
        }
    }
    else if(renderType == 'add'){
        odometerCheck = odometerCheck.min(data?.odometer + 1, `must be greater than last odometer ${data?.odometer} km!`)
        minDate = new Date(data.serviceDate)
    }else if(create){
        minDate = null
    }
    const validationSchema = Yup.object().shape({
        odometer: odometerCheck
          .required('Required'),
        expectedDistance: Yup.number('Number required').required('Required'),
        price: Yup.number('Number required').required('Required'),
        serviceDate: Yup.date().required('Required'),
      });
    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }
    const printDocument = (image) => () => {
        console.log("printDocumentprintDocument",image);
        if(!imageUrl){
          dispatch(
            getSignedUrlApiAction(
              { key: image },
              (res) => {
                // setDownloadLoader2(false);
                // setLoaderInvoiceId("");
                if (res.status == 200) {
                  setImageUrl(res?.data?.data)
                 
                }
              }
            )
          );
        }
        window.open(imageUrl);
      }
    
    return (
        <div>
            <div>
                <Formik
                // isValid='true'
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{
                    expectedDistance: create? "" : data?.expectedDuration,
                    odometer: create? "" :data?.odometer,
                    price: create? "" :data?.price,
                    serviceDate: create? "" :data?.serviceDate,
                    remarks: create? "" :data?.remarks,
                    imageUrl: create? "" :data?.imageUrl,
                    tagId: create? "" :data?.tagId,
                }}
                onSubmit={(values) => {
                    console.log("saveVehicleProfileData",values,type);
                    let objVal = {
                        expectedDuration: values.expectedDistance,
                        odometer: values.odometer,
                        price: values.price,
                        serviceDate: values.serviceDate,
                        remarks: values.remarks,
                        imageUrl: values.imageUrl,
                        tagId: values.tagId,
                        expenseType: type,
                        fleetId 
                    };

                    if(renderType == "edit"){
                        dispatch(editVehicleProfileData({...objVal,VehicleProfileId: data?.VehicleProfileId}, (res) => {
                            console.log("editVehicleProfileData");
                            if (res?.status == 200) {
                                notify("Profile Data Updated Successfully");
                                console.log("editVehicleProfileData",res?.data);
                                dispatch(getVehicleProfileData({fleetId: fleetId}, (res)=> {
                                    console.log("dispatchgetVehicleProfileData", res);
                                }));
                                console.log(objVal.odometer > vehicle?.currentOdometer, objVal.odometer, vehicle?.currentOdometer);
                                if(objVal.odometer > vehicle?.currentOdometer){
                                    dispatch(getUpdateFleet({fleetId: fleetId, currentOdometer: objVal.odometer}, (res)=> {
                                        console.log("getUpdateFleetgetUpdateFleet", res);
                                        dispatch(advancedVehicleListAction({
                                            offset: 0,
                                            search: "",
                                            limit: 15,
                                            activeStatus:1,
                                            assignedStatus:3,
                                            minKyc: "",
                                            sortAs: "",
                                            sortBy: "",
                                          }))
        
                                    }));
                                }
                            console.log("...............", res);
                            } else{
                                console.log("saveVehicleProfileData",res.response.data);
                                notify(res.response.data.message || "Profile Data Update Failed", true);
                            }
                        })
                        );
                    }else if(renderType!= "showItem"){
                        dispatch(saveVehicleProfileData(objVal, (res) => {
                            console.log("saveVehicleProfileDatasaveVehicleProfileData");
                            if (res?.status == 200) {
                                notify("Profile Data Updated Successfully");
                                console.log("saveVehicleProfileData",res?.data);
                                dispatch(getVehicleProfileData({fleetId: fleetId}, (res)=> {
                                    console.log("dispatchgetVehicleProfileData", res);
                                }));
                                console.log(objVal.odometer > vehicle?.currentOdometer, objVal.odometer, vehicle?.currentOdometer);
                                if(objVal.odometer > vehicle?.currentOdometer){
                                    dispatch(getUpdateFleet({fleetId: fleetId, currentOdometer: objVal.odometer}, (res)=> {
                                        console.log("getUpdateFleetgetUpdateFleet", res);
                                        dispatch(advancedVehicleListAction({
                                            offset: 0,
                                            search: "",
                                            limit: 15,
                                            activeStatus:1,
                                            assignedStatus:3,
                                            minKyc: "",
                                            sortAs: "",
                                            sortBy: "",
                                          }))
        
                                    }));
                                }
                            console.log("...............", res);
                            } else{
                                console.log("saveVehicleProfileData",res.response.data);
                                notify(res.response.data.message || "Profile Data Update Failed", true);
                            }
                        })
                        );
                    }
                    
                }}
                >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    resetForm,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form onSubmit={handleSubmit} >
                   <div style={{display:"flex", flexDirection:"row", marginTop: "1rem"}}>
                   <div className="col-6">
                    <FormGroup className="">
                        <FormGroup className="divClass">
                            <div className="col-6 heading3 semiBold">
                                Expected Distance:
                            </div>
                            <div className="col-6">
                                <input
                                    type="text"
                                    id="expectedDistance"
                                    disabled={renderType == "showItem"}
                                    className={`searchBar-input1 ${
                                    touched.expectedDistance && errors.expectedDistance ? "is-invalid" : ""
                                    }`}
                                    name="expectedDistance"
                                    onChange={(event) => {
                                    // setSearch(event.target.value);
                                    setFieldValue("expectedDistance", event.target.value, true);
                                    }}
                                    value={values.expectedDistance}
                                    touched={touched.expectedDistance}
                                    errors={errors.expectedDistance}
                                    placeholder="Km. "
                                    autoComplete={"off"}
                                />
                                 <div style={{ color: "red" }}>
                                {errors.expectedDistance && touched.expectedDistance ? (
                                <div>*{errors.expectedDistance}</div>
                                ) : null}
                            </div>
                            </div>
                           
                        </FormGroup>
                        <FormGroup className="divClass">
                        <div className="col-6 heading3 semiBold">
                                Price:
                            </div>
                            <div className="col-6">
                            <input
                                type="text"
                                id="price"
                                disabled={renderType == "showItem"}

                                className={`searchBar-input1 ${
                                touched.price && errors.price ? "is-invalid" : ""
                                }`}
                                name="price"
                                onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue("price", event.target.value, true);
                                }}
                                value={values.price}
                                touched={touched.price}
                                errors={errors.price}
                                placeholder="Rs. "
                                autoComplete={"off"}
                            />
                             <div style={{ color: "red" }}>
                                {errors.price && touched.price ? (
                                <div>*{errors.price}</div>
                                ) : null}
                            </div>
                        </div>

                        </FormGroup>
                        <FormGroup className="divClass">
                        <div className="heading3 semiBold">
                                Odometer Reading:
                            </div>
                            <div className="col-6">
                            <input
                                type="text"
                                id="odometer"
                                disabled={renderType == "showItem"}

                                className={`searchBar-input1 ${
                                touched.odometer && errors.odometer ? "is-invalid" : ""
                                }`}
                                name="odometer"
                                onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue("odometer", event.target.value, true);
                                }}
                                value={values.odometer}
                                touched={touched.odometer}
                                errors={errors.odometer}
                                onBlur={handleBlur("odometer")}
                                placeholder="Km"
                                autoComplete={"off"}
                            />
                             <div style={{ color: "red" }}>
                                {errors.odometer && touched.odometer ? (
                                <div>*{errors.odometer}</div>
                                ) : <></>}
                            </div>
                            </div>
                        </FormGroup>
                      
                    </FormGroup>
                    </div>  
                    <div className="col-6">
                        <FormGroup className="">
                    
                        <FormGroup className="divClass" style={{ display: "flex", flexDirection:"row" }}>
                        <div className="col-6 heading3 semiBold">
                                Service Date:
                            </div>
                        <div className="col-6" style={{ display: "flex", flexDirection:"row"}}>
                            <div className="col-9">
                            <DatePickerField
                                classname="searchBar-input1"
                                name="serviceDate"
                                header="Select Service Date"
                                value={values.serviceDate}
                                minDate={minDate}
                                maxDate={maxDate}
                                disabled={renderType == "showItem"}
                                
                                onChange={(v) => {
                                setFieldValue("serviceDate", v, true);
                                }}
                                ref1={datepickerRefServiceDate}
                                style={{ width: "100px" }}
                            />
                            </div>
                            <div className="col-3">
                            <label
                                className="date-input"
                                for="serviceDate"
                                style={{
                                position: "relative",
                                cursor: "pointer",
                                paddingLeft: "25px"
                                }}
                                onClick={() => {
                                handleClickDatepickerIcon();
                                }}
                            >
                                <SvgImage
                                name="CalenderLogo"
                                width="32"
                                height="32"
                                // classname="date-logo"
                                />
                            </label>
                            </div>
                        </div>
                        <div
                            className="heading4 Regular"
                            style={{ margin: "7px 0 0px 0", color: "red" }}
                        >
                            {errors.serviceDate && touched.serviceDate ? (
                            <div>*{errors.serviceDate}</div>
                            ) : null}
                        </div>
                        
                        
                        </FormGroup>
                        <FormGroup className="divClass">
                        <div className="col-6 heading3 semiBold">
                                Tag Id:
                            </div>
                            <div className="col-6">
                            <input
                                type="text"
                                id="tagId"
                                disabled={renderType == "showItem"}

                                className={`searchBar-input1 ${
                                touched.tagId && errors.tagId ? "is-invalid" : ""
                                }`}
                                name="tagId"
                                onChange={(event) => {
                                // setSearch(event.target.value);
                                setFieldValue("tagId", event.target.value, true);
                                }}
                                value={values.tagId}
                                touched={touched.tagId}
                                errors={errors.tagId}
                                placeholder="Tag Id"
                                autoComplete={"off"}
                            />
                            </div>
                            
                        </FormGroup>
                        {renderType != "showItem" ? 
                        <FormGroup className="divClass" style={{ marginRight: "20px" }}>
                        <label for="imageUrl" className="heading3 semiBold">
                            Upload Image
                        </label>
                        <div style={{ display: "flex" }}>
                            {!statusImage ? (
                            <p
                                className="heading4 Regular"
                                style={{ margin: "0px 20px" }}
                            >
                                Upload Image
                            </p>
                            ) : (
                            <></>
                            )}
                            {!statusImage ? (
                            <Button
                                className="add-attach"
                                type="button"
                            >
                                {imageLoader ? (
                                <div style={{ zIndex: 0 }}>
                                    <ClipLoader
                                    color={"#2E7C7B"}
                                    loading={true}
                                    size={20}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                    />
                                </div>
                                ) : (
                                <div>
                                    <SvgImage
                                    name="AddAttachment"
                                    height="25"
                                    width="25"
                                    />
                                    <input
                                    type="file"
                                    style={{ width: "25px" }}
                                    // multiple
                                    // accept="image/*"
                                    accept="image/*"
                                    className="add-attachment"
                                    onChange={(e) => {
                                        const img = e?.target.files[0];
                                        console.log("image", img?.name);

                                        const tempArray = Object.assign(
                                        [],
                                        values.docs
                                        );
                                        console.log("sel", tempArray);

                                        if (img == null) {
                                        //clear image
                                        setFieldValue("imageUrl", "", true);
                                        //for now  only one supported
                                        } else {
                                        console.log("upload", {
                                            img: img,
                                            uploadType: "aadharFront",
                                            isRes: true,
                                        });
                                        setImageLoader(true);
                                        dispatch(
                                            storeMedia(
                                            {
                                                img: img,
                                                uploadType: "aadharFront",
                                                isRes: false,
                                            },
                                            (res) => {
                                                setstatusImage(true);
                                                setDisplayNameImage((prev) => [
                                                { name: img?.name },
                                                ]);
                                                setImageLoader(false);
                                                if (res?.url) {
                                                console.log("opt", res);
                                                tempArray.push(res?.data?.Location);
                                                setFieldValue(
                                                    "imageUrl",
                                                    res?.url,
                                                    true
                                                );
                                                // setFieldValue('docs', tempArray, true);
                                                //for now  only one supported
                                                setFieldValue(
                                                    "docs",
                                                    [res?.data?.Location],
                                                    true
                                                );
                                                }
                                            }
                                            )
                                        );
                                        }
                                    }}
                                    />
                                </div>
                                )}
                                <div
                                style={{
                                    margin: "0px -16px 2px -14px",
                                    // color: "red",
                                }}
                                >
                                {errors.imageUrl && touched.imageUrl ? (
                                    <div>*{errors.imageUrl}</div>
                                ) : null}
                                </div>
                            </Button>
                            ) : (
                            <></>
                            )}
                            <div className="selected-img">
                            {statusImage ? (
                                displayNameImage?.map((d) => {
                                return (
                                    <div className="row">
                                    <div className="col-8">
                                        <p
                                        style={{
                                            color: "black",
                                            margin: "0px 10px 0",
                                            // padding: "0",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            window.open(d.link);
                                        }}
                                        >
                                        {d.name}
                                        </p>
                                    </div>
                                    <div
                                        className="col-4"
                                        onClick={() => {
                                        setstatusImage(false);
                                        }}
                                    >
                                        <text>Change</text>
                                    </div>
                                    </div>
                                );
                                })
                            ) : (
                                <></>
                            )}
                            </div>
                        </div>
                        </FormGroup> : <FormGroup className="divClass">
                        <div className="heading3 semiBold">
                        Image:
                        </div>
                        <div>
                        {data?.imageUrl ?  <div style={{display: "flex",flexDirection:"row" }}>
                        <button
                            style={{
                            border: 0,
                            backgroundColor: "#fff",
                            }}
                            onClick={() => {
                                if( !imageUrl){
                                    dispatch(getSignedUrlApiAction({ key: data?.imageUrl },(res) => {
                                        if (res.status == 200) {
                                            setImageUrl(res?.data?.data)
                                        }}
                                    ));
                                }
                            toggleImageModal()
                            }}><SvgImage name="viewInvoicesBlue" />
                        </button>
                        <div style={{marginLeft: "20px"}} onClick={  printDocument(data?.imageUrl)}>
                            <SvgImage name="downloadImg" width="24" height="24" />
                        </div>
                    </div>: (
              <SvgImage name="cancelOrder" height="21" width="21" />
            )}
                        </div>
                            </FormGroup>}
                    </FormGroup>
                    </div>     
                   </div>
                   <FormGroup className="divClass">
                            <div className="col-3 heading3 semiBold">
                                Remarks:
                            </div>
                            <div className="col-9">
                                <input
                                    type="text"
                                    id="remarks"
                                    disabled={renderType == "showItem"}

                                    className={`searchBar-input1 ${
                                    touched.remarks && errors.remarks ? "is-invalid" : ""
                                    }`}
                                    name="remarks"
                                    onChange={(event) => {
                                    // setSearch(event.target.value);
                                    setFieldValue("remarks", event.target.value, true);
                                    }}
                                    value={values.remarks}
                                    touched={touched.remarks}
                                    errors={errors.remarks}
                                    placeholder="Remarks"
                                    autoComplete={"off"}
                                    style={{width:"70%", marginLeft: "-37px"}}
                                />
                            </div>
                           
                        </FormGroup>
                   {renderType != "showItem" ? 
                   <FormGroup className="divClass" style={{justifyContent: "center", paddingTop: "20px"}}>
                   <Button
                       type="submit"
                       className="heading3 semiBold"
                       style={{width: "50%"}}>  {create ? <text> Create Profile</text> : renderType == "edit" ? <text> Edit Profile</text>: renderType == "insert" ? <text> Insert Profile</text>: <text> Update Profile</text>}
                       
                   </Button> 
               </FormGroup>:<></>}

                </Form>
                )}
                </Formik>
            </div>
            {imageModal ? <ImageModal
                toggle={toggleImageModal}
                imageModal={imageModal}
                setImageModal={setImageModal}
                image={imageUrl.split('?')[0]}
              />:<></>}
        </div>
    )
}

export default ProfileUpdateRender;

